import React, { ReactNode } from 'react';

import { TimelineEntryType } from '../../types/__generated__';

interface IContextProps {
  entryType?: TimelineEntryType | null;
}

// B2C_048 - show hide fitness data
// EntryType can be removed when experiment has ended
// or added as a non experiment test if successful
export const TimelineEntryTypeContext = React.createContext<
  Partial<IContextProps>
>({});

interface TimelineEntryTypeProvider extends IContextProps {
  children: ReactNode;
}

export function TimelineEntryTypeProvider({
  entryType,
  children,
}: TimelineEntryTypeProvider) {
  return (
    <TimelineEntryTypeContext.Provider value={{ entryType }}>
      {children}
    </TimelineEntryTypeContext.Provider>
  );
}
